import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

type Props = {
    showLogo?: boolean;
    text?: string;
    dots?: number;
    size?: 'sm' | 'md' | 'lg';
};

const sizeMap = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
};

const HubvexLoader: React.FC<Props> = ({
    showLogo = true,
    text,
    dots = 6,
    size = 'md',
}) => {
    const [active, setActive] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActive((prev) => (prev + 1) % dots);
        }, 300);

        return () => clearInterval(interval);
    }, [dots]);

    return (
        <div className="flex flex-col items-center justify-center gap-4">

            {/* LOGO */}
            {showLogo && (
                <motion.img
                    src="/assets/logo/favicon.png"
                    alt="Hubvex"
                    className={sizeMap[size]}
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{
                        duration: 1.2,
                        repeat: Infinity,
                        ease: 'easeInOut',
                    }}
                />
            )}

            {/* TEXT */}
            {text && (
                <motion.p
                    className="text-sm text-gray-600 tracking-wide"
                    initial={{ opacity: 0, y: 4 }}
                    animate={{ opacity: 1, y: 0 }}
                >
                    {text}
                </motion.p>
            )}

            {/* DOTS */}
            <div className="flex gap-2">
                {Array.from({ length: dots }).map((_, index) => {
                    const isActive = index === active;

                    return (
                        <motion.span
                            key={index}
                            className="w-2.5 h-2.5 rounded-full"
                            animate={{
                                scale: isActive ? 1.6 : 1,
                                backgroundColor: isActive ? '#00BCD4' : '#E5E7EB',
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default HubvexLoader;